import { createApp } from 'vue'
import App from './App.vue'
import router from "./router"
import axios from 'axios'
import VueWechatTitle from "vue-wechat-title";

// // 电信收货地址编码报表
import telcomAddress from './assets/js/telcom_address.json'
// // 联通收货地址编码报表
import unicomAddress from './assets/js/unicom_address.json'
// //电信屏蔽部分地区收货地址
import telcomAddressShiled from './assets/js/telcom_address_shiled.json'

import isIdcard from "./assets/js/idcard";

import {Button, Popup, Form, Field, Cascader, Checkbox, Dialog, CellGroup, Search ,NoticeBar, Swipe, SwipeItem ,Image as VanImage, Icon,Picker ,Loading ,Area   } from 'vant';
import 'vant/lib/index.css';




const app = createApp(App)
app.use(router)

app.use(VueWechatTitle)
app.use(Button).use(Popup).use(Form).use(Field).use(Cascader).use(Checkbox).use(Dialog).use(CellGroup).use(Search ).use(NoticeBar ).use(Swipe).use(SwipeItem )
    .use(VanImage).use(Icon).use(Picker ).use(Loading).use(Area)


app.mount('#app')
// 定义全局变量
app.config.globalProperties.$axios = axios;
// 服务端返回的执行成功的状态码
app.config.globalProperties.SUCCESS = '0000';

// 每页显示多少条记录
app.config.globalProperties.pageSize = 10

//电信屏蔽部分地区收货地址
app.config.globalProperties.telcomAddressShiled = telcomAddressShiled
// // 电信号码 收货地址以及对应编码
app.config.globalProperties.telcomAddress = telcomAddress
// // 联通号码 收货地址以及对应编码
app.config.globalProperties.unicomAddress = unicomAddress
app.config.globalProperties.isIdcard = isIdcard;

app.config.globalProperties.basePath = '/ad-web/'




